'use client';

import { useMemo } from 'react';
import { ICountryData } from '@/types/types/forms/dictionary/dictionary.interface';
import { IPhrases } from '@/types/types/page/pages';
import { useUpdatePhrases } from './useUpdatePhrases';

interface InitialPageLoadOptions {
    phrases?: IPhrases;
    countries: ICountryData[] | undefined;
    options?: {
        setDefaultLocale?: boolean;
    };
}

export const useInitialPageLoad = ({ phrases }: InitialPageLoadOptions) => {
    const phrasesAsString = JSON.stringify(phrases);
    const memoisedPhrases = useMemo(() => phrases, [phrasesAsString]);
    useUpdatePhrases(memoisedPhrases);
};
